export const EventType = Object.freeze({
    ORDER_CREATED: 1,
    ORDER_STATUS_CHANGED: 2,
    ORDER_STATUS_CHANGED_TO: 3,
    ORDER_STATUS_SCHEDULED_FOR: 4
})

